/* eslint-disable no-throw-literal */
import rules from "../constants/rules"
import i18n from "../locales/i18n";


const emailRule = rules.email;
const passwordRule = rules.password;


/**
 *
 * 整合表单错误埋点
 * @param {string} action 埋点action值
 */


//验证抛出的异常数组的第二位是为了给埋点信息添加状态，对提示信息无用，在App.less中特意添加样式隐藏了数组中第二个报错信息

const Validator = {
    /**
     *仅需要验证是否为填写的表单使用
     * @param {RuleObject} rule 验证规则 （可忽略）
     * @param {any} value 表单值
     */
    emptyValidator: async (rule, value) => {
        if (!value || (value && value.replace(/\s+/g, "") === "")) {

            throw [new Error(i18n.t("userLoginTips:Cannotbeemptyhere"))]; //此处不能为空
        }
        return true;
    },

    /**
     *email 基础验证
     * @param {RuleObject} rule 验证规则 （可忽略）
     * @param {any} value 表单值
     */
    emailValidator: async (rule, value) => {
        if (!value || (value && value.replace(/\s+/g, "") === "")) {

            throw [new Error(i18n.t("userLoginTips:Cannotbeemptyhere"))];
        } else if (!emailRule.test(value.replace(/(^\s*)|(\s*$)/g, ""))) {

            throw [new Error(i18n.t("userLoginTips:TheEmailformatisincorrect"))];
        } else {
            return true;
        }
    },

    /**
     *email 判断是否前后两个email是否相等
     * @param {RuleObject} rule 验证规则 （可忽略）
     * @param {any} value 表单值
     * @param {string} email 需要对比的email值
     */
    emailSameValidator: async (rule, value, email) => {
        if (!value || (value && value.replace(/\s+/g, "") === "")) {

            throw [new Error(i18n.t("userLoginTips:Cannotbeemptyhere"))];
        } else if (value.replace(/(^\s*)|(\s*$)/g, "") !== email.replace(/(^\s*)|(\s*$)/g, "")) {

            throw [new Error(i18n.t("userLoginTips:TheEmailformatisincorrect"))];
        } else {
            return true;
        }
    },

    /**
     *password 基础验证
     * @param {RuleObject} rule 验证规则 （可忽略）
     * @param {any} value 表单值
     */
    passwordValidator: async (rule, value) => {
        if (!value || (value && value.replace(/\s+/g, "") === "")) {

            throw [new Error(i18n.t("userLoginTips:Cannotbeemptyhere"))];
        } else if (!passwordRule.test(value)) {

            throw [new Error(i18n.t("userLoginTips:Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter"))];
        } else {
            return true;
        }
    },

    /**
     *password 判断是否前后两个email是否相等
     * @param {RuleObject} rule 验证规则 （可忽略）
     * @param {any} value 表单值
     * @param {string} password 需要对比的email值
     */
    passwordSameValidator: async (rule, value, password) => {
        if (!value || (value && value.replace(/\s+/g, "") === "")) {

            throw [new Error(i18n.t("userLoginTips:Cannotbeemptyhere"))];
        } else if (value !== password) {

            throw [new Error(i18n.t("userLoginTips:Pleaseenterthesamepasswordinbothfields"))];
        } else {
            return true;
        }
    },
};

export default Validator;
